import {Component, Input, OnInit} from '@angular/core';
import {CartSummary} from "../../../shared-core/models/cart-data.model";

@Component({
    selector: 'app-checkout-summary',
    templateUrl: './checkout-summary.component.html',
    styleUrls: ['./checkout-summary.component.scss']
})
export class CheckoutSummaryComponent implements OnInit {

    @Input() cartSummary: CartSummary;

    constructor() {
    }

    ngOnInit(): void {
    }

}
